import BadgesCell from "@/components/NewTable/BadgesCell";

export const columns = () => {
  return [
    {
      id: "code",
      accessorFn: (row) => `${row.code} - ${row.name}`,
      header: "Product",
    },
    {
      id: "versions",
      accessorFn: (row) => row.versions,
      header: "Version",
      enableSorting: false,
      cell: ({ row }) => <BadgesCell items={row.original.versions} />,
    },
  ];
};
